import React from 'react';

import { Text } from '@mantine/core';

import { APP_I18N_NAMESPACE } from '@root/lib/constants/common';
import { useTranslate } from '@root/lib/hooks/useTranslation';
import { type AtomComponent } from '@root/lib/types/components';

import { TicketCardConfig } from '../../components/Ticket/TicketCardConfig';
import { useCartStore } from '../../stores/cartStore';

/**
 * Event/Cart/CartViewContent atom component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const CartViewContentAtom: AtomComponent = () => {
	const { t } = useTranslate(APP_I18N_NAMESPACE.MAIN, CartViewContentAtom.displayName);
	const cartedTickets = useCartStore((s) => s.cartedTickets, 'none');

	return (
		<React.Fragment>
			{/* ticket listing section */}
			<section className="flex flex-col gap-2">
				{/* heading */}
				<Text fw={700} size="md" c="dimmed">
					{t('heading')}
				</Text>
				{/* tickets */}
				<div className="flex flex-col gap-3">
					{cartedTickets.map((ticket) => (
						<TicketCardConfig key={ticket.cartTicketId} cartTicketId={ticket.cartTicketId} />
					))}
				</div>
			</section>
		</React.Fragment>
	);
};

CartViewContentAtom.displayName = 'Event/Cart/CartViewContentAtom';
